import React, { Component, useEffect } from 'react'
import AppRoute from './users/NewRoute'

import { theme } from './Common/Credentials';
import { ThemeProvider } from '@mui/material/styles';
import SEO from './SEO/seo';
import './NewUI/NewUI.css'

// import theme from './theme';



const App = () => {
  const spinner = document.getElementById('spinner');

  const currentVersion = process.env.REACT_APP_VERSION;
  const clearCacheData = () => {
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
        console.warn('Cleared caches in this browser.');
      }).catch((error) => {
        console.error('Error clearing cache:', error);
      });
    } else {
      console.warn('Caches not available in this browser.');
    }

  };

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--UI-btn-primary-background",
      theme === "classic"
        ? "#4d4d4d" : "linear-gradient(to right, #2563eb, #4f46e5)"
    );
  }, [theme]);

  useEffect(() => {
    const checkAppVersion = async () => {
      try {
        // Fetch meta.json with a cache-busting timestamp parameter
        const res = await fetch(`/meta.json?t=${new Date().getTime()}`, {
          cache: 'no-cache',
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
          },
        });

        let serverVersion = currentVersion;
        if (res.ok) {
          const meta = await res.json();
          if (meta && meta.version) {
            serverVersion = meta.version;
          }
        }

        const storedVersion = localStorage.getItem('appVersion');

        if (storedVersion && storedVersion !== serverVersion) {
          console.warn(`New app version detected: ${serverVersion} (Stored: ${storedVersion}). Reloading page...`);
          localStorage.setItem('appVersion', serverVersion);
          clearCacheData();
          // Force a hard reload from server
          window.location.reload(true);
        } else if (!storedVersion && serverVersion) {
          localStorage.setItem('appVersion', serverVersion);
        }
      } catch (err) {
        console.error('Failed to check app version:', err);
      }
    };

    checkAppVersion();
  }, [currentVersion]);



  if (spinner && !spinner.hasAttribute('hidden')) {
    spinner.setAttribute('hidden', 'true');
  }
  return (
    <div className={`${theme === "classic" ? 'tw-bg-[#f8f2ec]' : 'tw-bg-[#fcfafd]'}`}>
      <SEO title={process.env.REACT_APP_FINANZZ_URL === "360" ? "360 ERP" : "Finanzz ERP"} />
      {/* <ThemeProvider theme={theme}> */}
      <AppRoute />
      {/* <NewAppRoute/> */}
      {/* </ThemeProvider> */}
    </div>
  )
}

export default App
